import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import * as Icon from 'react-feather';
import { FormattedMessage } from 'react-intl';
import {
  getCookieSettings,
  setCookieSettings,
} from '../../../../utility/util/util.service';

const CookieNotice = () => {
  const [activeSection, setActiveSection] = useState(null);
  const [closeAnimation, setCloseAnimation] = useState(false);
  const [allowNecessaryCookies, setAllowNecessaryCookies] = useState(false);
  const [allowFunctionalCookies, setAllowFunctionalCookies] = useState(false);
  const [allowMarketingCookies, setAllowMarketingCookies] = useState(false);

  const MAIN_SECTION = 'main_section';
  const OPTIONS_SECTION = 'options_section';

  const handleUseAllCookiesAndClose = () => {
    setAllowNecessaryCookies(true);
    setAllowFunctionalCookies(true);
    setAllowMarketingCookies(true);
    setCookieSettings(true, true, true);
    setCloseAnimation(true);
  };

  const handleSaveSelectionAndClose = () => {
    setCookieSettings(
      allowNecessaryCookies,
      allowFunctionalCookies,
      allowMarketingCookies,
    );
    setCloseAnimation(true);
  };

  // init process
  // if the cookies are not set, show the main_section
  useEffect(() => {
    const {
      allowNecessary,
      allowFunctional,
      allowMarketing,
    } = getCookieSettings();

    if (
      activeSection === null &&
      !(allowNecessary && allowFunctional && allowMarketing)
    ) {
      setActiveSection(MAIN_SECTION);
    }
  }, [activeSection]);

  return activeSection ? (
    <div
      style={{
        zIndex: '99999',
        width: '100vw',
      }}
      className={`d-flex justify-content-center position-fixed position-bottom-0 p-1 animate__animated ${
        closeAnimation
          ? 'animate__bounceOutDown'
          : 'animate__bounceInUp animate__delay-1s'
      }`}
      onAnimationEnd={() => {
        if (closeAnimation) {
          setActiveSection(null);
          setCloseAnimation(false);
        }
      }}
    >
      <div
        className="d-block m-0 px-2 py-1 text-white rounded bg-primary"
        style={{ maxWidth: '600px' }}
      >
        {activeSection === MAIN_SECTION && (
          <div className="d-block d-sm-flex align-items-sm-center">
            <span className="mr-sm-2 text-center text-sm-left">
              <FormattedMessage id="cookie_notice_main_section_text" />
            </span>
            <div>
              <Button.Ripple
                block
                size="md"
                color="white"
                className="w-100 mt-1 mt-sm-0"
                data-testid="acceptCookiesButton"
                onClick={() => handleUseAllCookiesAndClose()}
              >
                <span className="text-nowrap">
                  <FormattedMessage id="cookie_notice_accept_all_button" />
                </span>
              </Button.Ripple>
              <span
                className="d-block w-100 mt-1 mt-sm-50 text-center font-small-3"
                onClick={() => setActiveSection(OPTIONS_SECTION)}
              >
                <FormattedMessage id="cookie_notice_advanced_settings_button" />
              </span>
            </div>
          </div>
        )}

        {activeSection === OPTIONS_SECTION && (
          <div className="d-block d-sm-flex align-items-sm-center justify-content-sm-between">
            <span className="mr-md-2 align-self-center">
              <FormattedMessage id="cookie_notice_advanced_section_text" />
            </span>
            <div className="mt-1 mt-sm-0 mr-sm-2">
              <div
                onClick={() => setAllowNecessaryCookies(!allowNecessaryCookies)}
              >
                {allowNecessaryCookies ? (
                  <Icon.CheckSquare
                    color="white"
                    className="vx-icon mr-50"
                    size={24}
                  />
                ) : (
                  <Icon.Square
                    color="white"
                    className="vx-icon mr-50"
                    size={24}
                  />
                )}
                <span>
                  <FormattedMessage id="cookie_notice_necessary_checkbox_label" />
                </span>
              </div>
              <div
                onClick={() =>
                  setAllowFunctionalCookies(!allowFunctionalCookies)
                }
              >
                {allowFunctionalCookies ? (
                  <Icon.CheckSquare
                    color="white"
                    className="vx-icon mr-50"
                    size={24}
                  />
                ) : (
                  <Icon.Square
                    color="white"
                    className="vx-icon mr-50"
                    size={24}
                  />
                )}
                <span>
                  <FormattedMessage id="cookie_notice_functional_checkbox_label" />
                </span>
              </div>
              <div
                onClick={() => setAllowMarketingCookies(!allowMarketingCookies)}
              >
                {allowMarketingCookies ? (
                  <Icon.CheckSquare
                    color="white"
                    className="vx-icon mr-50"
                    size={24}
                  />
                ) : (
                  <Icon.Square
                    color="white"
                    className="vx-icon mr-50"
                    size={24}
                  />
                )}
                <span>
                  <FormattedMessage id="cookie_notice_marketing_checkbox_label" />
                </span>
              </div>
            </div>
            <div>
              <Button.Ripple
                block
                size="md"
                color="white"
                className="w-100 mt-1 mt-sm-0"
                onClick={() => handleUseAllCookiesAndClose()}
              >
                <span className="text-nowrap">
                  <FormattedMessage id="cookie_notice_accept_all_button" />
                </span>
              </Button.Ripple>
              <span
                className="d-block w-100 mt-1 mt-sm-50 text-center font-small-3"
                onClick={() => handleSaveSelectionAndClose()}
              >
                <FormattedMessage id="cookie_notice_save_selection_button" />
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  ) : null;
};

export default CookieNotice;
